module.exports = __webpack_public_path__ + "assets/img/no_friends_post.38e7930a.png";